import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    admin: false,
    socket: {
      connected: false,
    },
    clinicFormInvalid: {
      invalid: true,
      clinic: false,
    },
    formDataClinic: null,
    socketMessages: {
      connected: false,
    },
    idInstLab: null,
    newNotifications: null,
    active: false,
    idSign: "",
    showSign: false,
    user: {
      email: "",
      user: "",
      idInstitution: "",
      pussy: "",
      role: "",
      defaultPhotoUser: null,
      defaultAvatarUser: null,
      defaultBackground: null,
    },
    activeComponents: true,
    easyPatient: {
      personalInformation: true,
      consultations: false,
      exams: false,
      immunizations: false,
      imaging: false,
      laboratory: false,
      prescriptions: false,
      measurements: false,
    },
    language: "es",
    signImage: null,
    srcImage: "",
    imageDownload: null,
    switch: {
      physician: false,
      status: null,
    },
    easyFindMe: {
      id_person: null,
      role: null,
      name: null,
      gender: null,
      age: null,
      country: null,
      city: null,
      specialty: null,
      subSpecialty: null,
      experience: null,
      yearsService: null,
      social: {
        facebook: {
          displayed: false,
        },
        twitter: {
          displayed: false,
        },
        linkedin: {
          displayed: false,
        },
        instagram: {
          displayed: false,
        },
        web_site: {
          displayed: false,
        },
      },
      show: {
        id_person: null,
        role: null,
        user: null,
        image: null,
        email: null,
        specialty: null,
        subSpecialty: null,
        view: null, // null=> cuando es un nuevo paciente, 1=> cuando comienza una nueva consulta, 2=> cuando es solo show
        shared: null,
        category: null,
      },
    },
    easyFindMeProfessional: {
      personalInformation: true,
      addressConsultants: false,
      photosProfessional: false,
      servicesProfessional: false,
      paymentSettings: false,
      experienceProfessional: false,
      opinionProfessional: false,
    },
    easyFindMeInstitution: {
      dataProfileInstitution: true,
      dataServicesInstitution: false,
      dataPhotosInstitution: false,
      dataOpinionInstitution: false,
      dataSpecialtyConsultationInstitution: false,
    },
    easyFindMePatient: {
      dataProfilePatient: true,
    },
    showEasyFindMePatient: {
      showPersonalInformationPatient: true,
      showConsultationsPatient: false,
      showExamsPatient: false,
      showInmunizationsPatient: false,
      showImagingPatient: false,
      showLaboratoryPatient: false,
      showPrescriptionsPatient: false,
      showMeasurementsPatient: false,
    },
    showEasyFindMeInstitution: {
      showInformationInstitution: true,
      showServicesInstitution: false,
      showOpinionInstitution: false,
      showPhotosInstitution: false,
    },
    showEasyFindMeProfessional: {
      showInformationProfessional: true,
      showConsultationsProfessional: false,
      showServicesProfessional: false,
      showExperienceProfessional: false,
      showPhotosProfessional: false,
      showOpinionProfessional: false,
    },
    prescriptionsVideoConsultation: false,
    menuVisible: true,
    persistent: "full",
    stepDx: {
      dataPersonal: false,
      antecedent: true,
      consultation: true,
      paraclinics: true,
      diagnostic: true,
      prescription: true,
    },
    configAppoint: {
      idInstitution: null,
      idPhysician: null,
      office: null, // only for professionals
      services: [
        // Almacenara el tipo de servicio y los horarios configurados para el mismo
        // servicesConfigAppoint
      ],
      specialty: null,
    },
    servicesConfigAppoint: {
      type_service: null,
      schedule: [
        // scheduleConfigAppoint
      ],
      notifications: {
        confirm_quote: {
          active: false,
        },
        reminder1_quote: {
          active: false,
        },
        reminder2_quote: {
          active: false,
        },
        kind: [], // type = message, email, sms, gcalendar
      },
      assistant_assigned: [], //id :string,  permission_assistant :ArrayString (create,write,read,delete)
      permission_patient: false,
      show_physician: false,
      waiting_list: {
        high_priority: { active: false, duration: 0, type: null },
        medium_priority: { active: false, duration: 0, type: null },
        low_priority: { active: false, duration: 0, type: null },
      },
      anticipation: 5,
      disabled_schedule: [],
    },
    scheduleConfigAppoint: {
      duration: 0,
      max_cite: 0,
      days: [],
      horary: {
        from: null,
        to: null,
      },
      responsible: [],
      type_consulting: [],
      multiple_cite: 1,
      active: false,
    },
    appoiment: {
      filter: {
        physician: [],
        institution: [],
        institutionServices: [],
      },
      calendarFilter: [
        // En este punto se mantendra la configuracion completa aplicada de los filtros
      ],
      scheduleFilter: {
        // Aca se matendra unicamente los horarios disponibles y no dispobibles segun el tipo de consulta a partir de la configuración filtrada
        schedule: [],
        disabled_schedule: [],
      },
      horaryAux: null,
    },
  },
  easy: {
    active: false,
    activeComponents: true,
  },
  mutations: {
    updateStore(state, payload) {
      if (payload.item) {
        let storeAux = payload.item.split(".");
        switch (String(storeAux.length)) {
          case "2":
            // console.log('2')
            state[payload.name][storeAux[0]][storeAux[1]] = payload.value;
            // console.log(state.configAppoint[storeAux[0]][storeAux[1]][storeAux[2]])
            break;
          case "3":
            // console.log('3')
            state[payload.name][storeAux[0]][storeAux[1]][storeAux[2]] =
              payload.value;
            // console.log(state.configAppoint[storeAux[0]][storeAux[1]][storeAux[2]])
            break;
          case "4":
            // console.log('4')
            state[payload.name][storeAux[0]][storeAux[1]][storeAux[2]][
              storeAux[3]
            ] = payload.value;
            // console.log(state.configAppoint[storeAux[0]][storeAux[1]][storeAux[2]][storeAux[3]])
            break;
          default:
            if (payload.isArray) {
              if (payload.removeArray) {
                let position = payload.item.split(".");
                switch (String(position.length)) {
                  case "2":
                    state[payload.name][payload.position[0]][
                      payload.position[1]
                    ].splice(payload.value, 1);
                    break;
                  default:
                    state[payload.name][payload.item].splice(payload.value, 1);
                    break;
                }
              } else {
                state[payload.name][payload.item].push(payload.value);
              }
            } else {
              state[payload.name][payload.item] = payload.value;
            }
            // console.log(`Despues ${payload.item}: `, state[payload.name][payload.item])
            break;
        }
      } else {
        state[payload.name] = payload.value;
      }
    },
    sendDataClinic(state, payload) {
      state.formDataClinic = payload.obj;
    },
    changeRegisterClinic(state, payload) {
      if (payload.clinic) {
        state.clinicFormInvalid.clinic = payload.clinic;
      } else {
        state.clinicFormInvalid.invalid = payload.invalid;
      }
    },
    updateShowSign(state, payload) {
      state.showSign = payload.value;
    },
    updateSignId(state, payload) {
      state.idSign = payload.id;
    },
    updateSignStore(state, payload) {
      state.signImage = payload.url;
    },
    socketio(state, payload) {
      state.socket = payload.socket;
    },
    socketioM(state, payload) {
      state.socketMessages = payload.socket;
    },
    idInstLab(state, payload) {
      state.idInstLab = payload.id;
    },
    menuVisible(state, payload) {
      state.menuVisible = payload.state;
    },
    persistent(state, payload) {
      state.persistent = payload.state;
    },
    showDialog(state) {
      state.active = state.active == true ? false : true;
    },
    sessionStorage(state, payload) {
      Vue.set(state.user, "email", payload.email);
      Vue.set(state.user, "user", payload.user);
      Vue.set(state.user, "idInstitution", payload.idInstitution);
      Vue.set(state.user, "pussy", payload.pussy);
      Vue.set(state.user, "role", payload.role);
    },
    showComponents(state, payload) {
      state.activeComponents = payload.state;
    },
    showEasy(easy, payload) {
      easy.activeComponents = payload.easy;
    },
    showEasyPatient(easy, payload) {
      easy.easyPatient = payload.state;
    },
    changeLanguage(state, payload) {
      Vue.set(state.language, "lang", payload.lang);
    },
    changeSrc(state, payload) {
      state.srcImage = payload.srcImage;
      state.imageDownload = payload.imageDownload;
    },
    easyFindMe(state, payload) {
      state.easyFindMe = payload.state;
    },
    newNotifications(state, payload) {
      state.newNotifications = payload.state;
    },
    changePrescriptionDx(state, payload) {
      state.stepDx = payload.state;
    },
    changeAppointment(state, payload) {
      state.appoiment.horaryAux = payload.value;
    },
    setAdmin(state, payload) {
      state.admin = payload;
    },
  },
  getters: {
    getUser: (state) => state.user.pussy,
    getValidForm: (state) => state.clinicFormInvalid,
    getComponents(state) {
      return state.activeComponents;
    },
    getFormClinic: (state) => state.formDataClinic,
    getShowSignDigital: (state) => state.showSign,
    getEasy(easy) {
      return easy.activeComponents;
    },
    getEasyPatient(easy) {
      return easy.easyPatient;
    },
    getSrcImage: (state) => state.srcImage,
    getSignImage: (state) => state.signImage,
    getImage: (state) => state.imageDownload,
    getEasyFindMe: (state) => state.easyFindMe,
    getEasyFindMeProfessional: (state) => state.easyFindMeProfessional,
    getEasyFindMeInstitution: (state) => state.easyFindMeInstitution,
    getEasyFindMePatient: (state) => state.easyFindMePatient,
    getShowEasyFindMePatient: (state) => state.showEasyFindMePatient,
    getShowEasyFindMeInstitution: (state) => state.showEasyFindMeInstitution,
    getShowEasyFindMeProfessional: (state) => state.showEasyFindMeProfessional,
    getNewNotifications: (state) => state.newNotifications,
    getShowTypePrescription: (state) => state.prescriptionsVideoConsultation,
    getValidationStepDx: (state) => state.stepDx,
    getmenuVisible: (state) => state.menuVisible,
    getpersistent: (state) => state.persistent,
    getidInstLab: (state) => state.idInstLab,
    getsocket: (state) => state.socket,
    getsocketM: (state) => state.socketMessages,
    getConfigAppoint: (state) => state.configAppoint,
    getServicesConfig: (state) => state.servicesConfigAppoint,
    getScheduleConfig: (state) => state.scheduleConfigAppoint,
    getAppoint: (state) => state.appoiment,
    getHoraryAppoint: (state) => state.appoiment.horaryAux,
    getSignId: (state) => state.idSign,
    getSwitch: (state) => state.switch,
    getAdmin: (state) => state.admin,
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js